import { gql } from '@apollo/client';

export const DELETE_REQUIREMENTS = gql`
	mutation deleteRequirements($requirementIds: [ID]){
		deleteRequirementEntity(requirementEntityIds: $requirementIds) {
			id
		}
	}
`;

export const getRequirementQueryWithLevels = (levels: number): string => {
	return `
		requirements {
			id
			created
			modified
			name
			displayName
			description
			requirementType
			displayOnSidebar
			condition
			compulsory
			category
			programStructureId
			rootProgramStructureId
			parentRequirementId
			showDiscontinuedCourses
			unitConditions {
				id
				ruleType
				units
				requirementId
			}
			courseOfferings {
				id
				studyPeriod
				yearLevel
				requirement
				prerequisite
				enabled
				note
				programRequirementId
				campusId
				campus {
					id
					name
				}
				isDefaultTerm
				termId
				term {
					id
					name
					order
					studyPeriodId
					studyPeriod {
						id
						name
						order
					}
				}
				course {
					id
					code
					name
					level
					requisiteLogicGroups {
						id
						isTopLevelGroup
						description
					}
				}
			}
			${levels > 0 ? getRequirementQueryWithLevels(levels - 1) : ''}
		}
	`;
};

export default {
	getRequirementQueryWithLevels,
};
